export default "__VITE_ASSET__d7ebfb69__"